import React, { Component, Fragment } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { readableResponseMessage } from "ux-helpers";
import { Auth, API } from "aws-amplify";
import Modal from "react-modal";
import ReactCrop from "react-image-crop";
import PropTypes from "proptypes";

import "./PortalHeader.scss";

class PortalHeader extends Component {
  state = {
    profileImage: "",
    crop: {
      aspect: 1 / 1
    },
    activeModal: null,
    user: {
      profilePicture: null
    }
  };

  onImageSelect = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () =>
          this.setState({
            profileImage: reader.result
          }),
        false
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    this.openModal("profileImageModal");
  };

  onCropComplete = crop => {
    this.setState({ crop });
  };

  onCropChange = crop => {
    this.setState({ crop });
  };

  updateProfileImage = e => {
    if (Object.keys(this.state.crop).length <= 1) {
      this.setState({ message: "Please crop your Photo" });
    } else {
      e.preventDefault();
      this.setState({ loadingBtn: true });
      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            "Content-Type": "application/json"
          },
          body: {
            profileImageBase64: this.state.profileImage,
            profileImageCrop: this.state.crop,
            username: user.idToken.payload.nickname
          }
        };
        API.put("give-api", "/user", options)
          .then(response => {
            const user = {
              ...this.props.user,
              profilePicture: response.Data.profilePicture
            }
            this.props.setAppState(user);
            this.setState({
              loadingBtn: false,
              message: response.Message
            });
            setTimeout(() => {
              this.setState({ message: "" });
              this.closeModal();
            }, 2000);
          })
          .catch(error => {
            this.setState({
              loadingBtn: false,
              message: readableResponseMessage(error)
            });
          });
      });
    }
  };

  uploadPhotoFlow = () => {
    document.getElementsByClassName("profile-pic-placeholder")[0].click();
  };

  openModal = modalName => {
    this.setState({
      activeModal: modalName
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null
    });
  };

  resetUploadHandler = e => {
    e.target.value = null;
  };

  render() {
    const { user, title } = this.props;

    return (
      <Fragment>
        <div className="row portal-header" id="top">
          <div className="col-md-6 dash-panel">
            <h2 id="welcome">{title}</h2>
          </div>
          <div className="col-md-6 dash-panel">
            {user &&
            user.trips !== undefined &&
            !user.trips.length &&
            user.pastTrips.length ? (
              ""
            ) : (
                <NavLink
                  className="small-link inline"
                  activeClassName="hidden"
                  to="/portal-home"
                >
                  My Trips
                </NavLink>
            )}
            {/* <NavLink
              className="small-link inline"
              activeClassName="hidden"
              to="/trip-selection"
            >
              Add Another Trip
            </NavLink> */}
            <NavLink
              className="small-link inline"
              activeClassName="hidden"
              to="/profile"
            >
              My Profile
            </NavLink>
            {user &&
              user.pastTrips !== undefined &&
              user.pastTrips.length &&
              user.pastTrips.length > 0 ? (
                <NavLink
                  className="small-link inline"
                  to="/profile#past-trips"
                >
                  Trip History
                </NavLink>
              ) : (
                  ""
            )}
            <div className="profile-pic">
              <form name="Portal Header" id="portalheaderForm">
                <button className="profile-pic-placeholder">
                  <img
                    className={`${
                      user.profilePicture && user.profilePicture.length
                        ? "profile-pic-container"
                        : "hidden"
                    }`}
                    src={user.profilePicture}
                    alt=""
                  />
                  <input
                    className="profile-image-upload-input"
                    type="file"
                    onClick={e => this.resetUploadHandler(e)}
                    onChange={this.onImageSelect}
                  />
                  Upload your photo
                </button>
              </form>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.activeModal === "profileImageModal"}
          onRequestClose={() => {
            this.setState({ activeModal: null });
          }}
          overlayClassName="overlay"
        >
          <br />
          <button className="square-icon right" onClick={this.closeModal}>
            X
          </button>
          <div>
            <ReactCrop
              src={this.state.profileImage}
              crop={this.state.crop}
              onChange={this.onCropChange}
              onComplete={this.onCropComplete}
            />
          </div>
          {this.state.message ? (
            <p
              id="error"
              className={`center ${
                this.state.message === "Your profile was successfully updated."
                  ? "success"
                  : "error"
              }`}
            >
              {this.state.message}
            </p>
          ) : (
            ""
          )}
          <button
            onClick={e => this.updateProfileImage(e)}
            className={`${this.state.loadingBtn ? "btn-text-hide" : ""}`}
            type="submit"
            disabled={this.state.loadingBtn}
          >
            Submit
            <span className={`${this.state.loadingBtn ? "loader" : ""}`} />
          </button>
          <p>
            Please crop your image by clicking and dragging over the area you'd
            like to display for your profile image.
          </p>
        </Modal>
      </Fragment>
    );
  }
}

PortalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  setAppState: PropTypes.func
};

export default withRouter(PortalHeader);
